import { useEffect } from 'react';

/**
 * House rule: modals close on ESC unless mid-blocking-operation. `Modal`
 * itself (packages/admin/src/components/Modal.tsx) already closes on a
 * backdrop click but has no ESC handling of its own and is out of scope for
 * this piece of work, so every modal this work touches wires this locally
 * instead of a shared change to that component.
 */
export function useEscToClose(onClose: () => void, blocked = false): void {
  useEffect(() => {
    if (blocked) return;
    function onKeyDown(e: KeyboardEvent): void {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose, blocked]);
}
